module.exports = (Promise.resolve(__parcel__require__("./" + "Debugger.worker.77753fbf.bed794fd.2d4aa70f.js"))).then(() => parcelRequire('fdJ4H'));